import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AdminReset = ({ adminId, adminGroup }) => {
    console.log(`🚀 AdminReset Loaded - Admin ID: ${adminId}, Group: ${adminGroup}`);

    const [username, setUsername] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (adminId === undefined || adminGroup === undefined) {
            console.warn("⚠️ Waiting for Admin Data...");
        } else if (adminGroup !== 1) {
            alert("❌ Unauthorized: Only Admins can reset passwords.");
            navigate("/");
        }
    }, [adminId, adminGroup, navigate]);

    const handleReset = async (e) => {
        e.preventDefault();
        console.log("🚀 Attempting password reset:", { adminId, username, newPassword });

        if (!adminId || adminGroup !== 1) {
            alert("❌ Unauthorized: Only Admins can reset passwords.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/reset-password`, {


                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ adminId, username, newPassword }),
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error);

            alert(`✅ Password reset successful for ${username}`);
            setUsername("");
            setNewPassword("");
        } catch (error) {
            alert(`❌ Error: ${error.message}`);
        }
    };

    // 🔹 ✅ Don't render form if Admin ID & Group aren't loaded yet
    if (adminId === undefined || adminGroup === undefined) {
        return <p>🔄 Loading Admin Data...</p>;
    }

    return (
        <div>
            <h2>Admin Password Reset</h2>
            <form onSubmit={handleReset}>
                <input
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <button type="submit">Reset Password</button>
            </form>
        </div>
    );
};

export default AdminReset;
